<!--
src:播放地址
isShow :是否显示播放器
callback:function
-->

<template>
  <div class="v-video-box" v-if="isShow">
    <div class="text-right v-video-wrap">
      <span class="iconfont iconguanbi theme-icon-primary-color v-close pointer" @click="closeVideo"></span>
      <img v-if="isHomeSlider && externalLink" class="goBtn" :src="goBtn" @click="openExternalLink"/>
      <video controls :src="src" v-if="src" autoplay>
        {{ $t('upgradeBrowser') }}
      </video>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import goBtnCn from '@/assets/homeImages/goBtnCn.png'
import goBtnEn from '@/assets/homeImages/goBtnEn.png'
export default {
  props: {
    src: {
      type: [String],
      default: () => ''
    },
    isShow: {
      type: [Boolean],
      default: () => false
    },
    // 首页滚动图片视频，弹窗显示进入按钮
    isHomeSlider: {
      type: Boolean,
      default: false
    },

    externalLink: {
      type: String,
      default: ''
    },

    options: {
      type: Object,
      default: () => {}
    }
  },
  name: 'vVideo',

  computed: {
    ...mapGetters(['language'])
  },

  mounted() {
    this.goBtn = this.language === 'en' ? goBtnEn : goBtnCn
  },

  components: {},
  data() {
    return {}
  },
  methods: {
    closeVideo() {
      this.$emit('callback', { type: 'video', data: { event: 'close' } })
    },
    openExternalLink() {
      let data = this.options
      this.commonStatistics('001033000', {url: data.url})
      if (data.type == 'ACTOR' && data.externalLink) {
        this.pageDetail({id: data.externalLink}, 'actor')
      } else if (data.type == 'EXTERNAL' && data.externalLink) {
        window.open(data.externalLink, '_blank')
      }
      this.closeVideo()
    }
  }
}
</script>
<style lang="stylus" scoped>
.v-video-box{
    position:fixed;
    top:0;
    left:0;
    right:0;
    bottom:0;
    background:$color-black-65;
    width:100%;
    height:100%;
    min-height:100vh;
    z-index:1002;
    .v-video-wrap{
        position:fixed;
        width:80%;
        max-width:$container-width;
        height:80%;
        top:50%;
        left:50%;
        transform:translate(-50%,-50%)
        video{
            position:fixed;
            width:100%;
            height:100%;
            top:50%;
            left:50%;
            transform :translate(-50%,-50%)
            background: $color-black;
        }
        .v-close{
          position: absolute;
          margin-top: 0;
          height: 43px;
          font-size: 43px;

          &:hover {
            color: $color-light9
          }
        }
        .goBtn {
            position: absolute;
            top: 20px;
            right: 20px;
            z-index: 2;
            cursor: pointer;
        }
    }
}
</style>
